<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirmLoading="submitLoading"
    @ok="submitForm"
    @cancel="onClose"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item :label="$t('入驻审核.角色类型')">
        <a-tag :color="worker.workerType === 1 ? 'blue' : worker.workerType === 2 ? 'green' : 'orange'">
          {{ worker.workerTypeName }}
        </a-tag>
      </a-form-model-item>
      <a-form-model-item :label="$t('入驻审核.姓名')">
        {{ worker.name }}
      </a-form-model-item>
      <a-form-model-item :label="$t('入驻审核.联系方式')">
        {{ worker.contactPhone }}
      </a-form-model-item>
      <a-form-model-item :label="$t('入驻审核.审核状态')">
        <a-tag :color="worker.auditStatus === 0 ? 'orange' : worker.auditStatus === 1 ? 'green' : 'red'">
          {{ worker.auditStatusName }}
        </a-tag>
      </a-form-model-item>
      <a-form-model-item :label="$t('入驻审核.审核结果')" prop="auditStatus">
        <a-select v-model="form.auditStatus" :placeholder="$t('入驻审核.请选择审核结果')" @change="handleStatusChange">
          <a-select-option v-for="(item, index) in auditStatusOptions" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('入驻审核.审核备注')" prop="auditRemark">
        <a-textarea v-model="form.auditRemark" :rows="3" :maxLength="200" :placeholder="$t('入驻审核.请输入审核备注')" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { auditWorker } from '@/api/homeworker/worker'
import { AUDIT_STATUS_OPTIONS, AUDIT_STATUS } from '../auditStatus'

export default {
  name: 'AuditForm',
  data() {
    return {
      visible: false,
      title: '',
      // 是否修改审核（非待审核状态下再次审核）
      isEdit: false,
      submitLoading: false,
      worker: {},
      // 审核状态选项：不使用 customDict.AuditStatusEnum（后端同名枚举会互相覆盖），使用本地定义
      auditStatusOptions: AUDIT_STATUS_OPTIONS,
      form: {
        id: null,
        auditStatus: null,
        auditRemark: null
      },
      rules: {}
    }
  },
  methods: {
    show(row, auditStatus) {
      this.worker = row
      this.isEdit = row.auditStatus !== AUDIT_STATUS.PENDING
      this.form = {
        id: row.id,
        auditStatus: auditStatus !== null && auditStatus !== undefined ? auditStatus : row.auditStatus,
        auditRemark: null
      }
      this.title = this.isEdit ? this.$t('入驻审核.修改审核') : this.$t('入驻审核.审核详情')
      this.visible = true
      this.buildRules()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleStatusChange() {
      this.buildRules()
    },
    buildRules() {
      // 拒绝时备注必填
      if (this.form.auditStatus === AUDIT_STATUS.REJECT) {
        this.rules = {
          auditRemark: [{ required: true, message: this.$t('入驻审核.请输入拒绝原因'), trigger: 'blur' }]
        }
      } else {
        this.rules = {}
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          auditWorker(this.form).then(() => {
            this.$message.success(this.$t('通用.文本.操作成功'))
            this.onClose()
            this.$emit('ok')
          }).finally(() => { this.submitLoading = false })
        }
      })
    },
    onClose() {
      this.visible = false
    }
  }
}
</script>
